module.exports = __webpack_public_path__ + "img/distribute.4af02585.svg";